<a routerLink="/files" class="item flex" [class.unread]="filesUnread > 0" matRipple routerLinkActive="active" (click)="checkFiles()">
  <i class="fa-regular fa-folders item-icon mr-4 flex-none"></i>
  <span *ngIf="filesUnread > 0" class="item-badge text-cyan-contrast flex-none">{{ filesUnread }}</span>

  <span class="item-label flex-auto" i18n>Files</span>
</a>
